
const ENV = {
	LOCUSB_API:'https://prod.locusb.com/JobTracking',
	REACT_APP_SECURE_TOKEN: 'Basic bXlhcHA6Z3Vlc3NtZQ=='
};

export default ENV;
